import {
  ESubRollingOfferCollectBehavior,
  ESubRollingOfferCollectMode,
} from 'utils/enums';
import { SequencedProduct, SequencedProductRollingOffer } from 'utils/types';
import { SubRollingOfferProps, SubRollingOfferUiProps } from './types';

export const arrowHeightWidth = 20;
export const containerPadding = 12;
export const subOfferHeight = 152;
export const maxHeight = 546;

const getCollectMode = ({
  indexToCollect,
  offerIndex,
}: {
  indexToCollect: number;
  offerIndex: number;
}): ESubRollingOfferCollectMode => {
  if (offerIndex < indexToCollect) return ESubRollingOfferCollectMode.COLLECTED;
  if (offerIndex > indexToCollect) return ESubRollingOfferCollectMode.LOCKED;

  return ESubRollingOfferCollectMode.AVAILABLE;
};

const filterOffersByCollectMode = ({
  subRollingOffersProducts,
  collectBehavior,
  indexToCollect,
}: {
  subRollingOffersProducts: SequencedProduct[];
  collectBehavior: ESubRollingOfferCollectBehavior;
  indexToCollect: number;
}): SequencedProduct[] => {
  // If collect mode is stay, we don't need to filter out collected offers
  if (collectBehavior === ESubRollingOfferCollectBehavior.STAY)
    return subRollingOffersProducts;

  return subRollingOffersProducts.filter(
    ({ index }) => index >= indexToCollect,
  );
};

const getSubRollingOffersFromProducts = ({
  indexToCollect,
  subRollingOffersProducts,
  subRollingOfferUiProps,
  collectBehavior,
  selectOffer,
}: {
  indexToCollect: number;
  subRollingOffersProducts: SequencedProductRollingOffer[];
  subRollingOfferUiProps: SubRollingOfferUiProps;
  collectBehavior: ESubRollingOfferCollectBehavior;
  selectOffer: () => void;
}): SubRollingOfferProps[] => {
  const filteredOffersProducts: SequencedProductRollingOffer[] =
    filterOffersByCollectMode({
      subRollingOffersProducts,
      collectBehavior,
      indexToCollect,
    });
  return filteredOffersProducts.map(
    (subRollingOfferProduct: SequencedProductRollingOffer) => ({
      ...subRollingOfferProduct,
      ...subRollingOfferUiProps,
      selectOffer,
      index: subRollingOfferProduct.index,
      collectMode: getCollectMode({
        indexToCollect,
        offerIndex: subRollingOfferProduct.index,
      }),
      emblemBadges: subRollingOfferProduct.offerBadges?.emblems ?? [],
    }),
  );
};

export const rollingOfferUtils = {
  getSubRollingOffersFromProducts,
};
